import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNoValue = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 8.25,
		cy: 8.25,
		r: 7.625,
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "square",
		strokeLinejoin: "round",
		strokeDasharray: "0.5 6"
	})
});
export default SvgNoValue;
